"use strict";
exports.__esModule = true;
exports.CONTACT_SUPPORT = void 0;
exports.CONTACT_SUPPORT = {
    HEADER: 'Something went wrong',
    BODY_1: 'Due to technical issues, we were unable to process your application.',
    BODY_2: 'Please contact our support team, and someone will get in touch.',
    CTA: 'Contact support'
};
